import { render, staticRenderFns } from "./FluidPicker.vue?vue&type=template&id=bb8bf8fa&"
import script from "./FluidPicker.vue?vue&type=script&lang=js&"
export * from "./FluidPicker.vue?vue&type=script&lang=js&"
import style0 from "./FluidPicker.vue?vue&type=style&index=0&id=bb8bf8fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports